<template>
  <div
    class="box"
    style="padding-right: 0 !important; min-height: calc(100vh - 100px)"
  >
    <div class="">
      <div class="d-flex">
        <div>
          <santakButton
            title="取消"
            @clickHandle="goIndex"
            isActive="true"
            style="margin: 20px; margin-bottom: 0"
          ></santakButton>
          <santakButton
            title="保存并返回"
            @clickHandle="addNewServer"
            isActive="true"
            style="margin: 20px; margin-bottom: 0"
          ></santakButton>
        </div>
      </div>
      <div class="p-y-3">
        <div class="j-sb" style="flex-wrap: wrap">
          <div class="d-flex a-center" style="margin-bottom: 26px">
            <santakinput
              santakLabel="活动名称"
              labelWidth="116"
              field="queryInfo"
              fieldName="activityName"
              :defaultValue="queryInfo.activityName"
              :isRequired="true"
            ></santakinput>
            <div
              style="
                text-align: right;
                padding-right: 10px;
                font-size: 0.875rem;
                width: 7.25rem;
                margin-left: 150px;
              "
            >
              报名截止时间
            </div>
            <el-date-picker
              v-model="queryInfo.startTime"
              type="datetime"
              placeholder="选择截止时间"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </div>
          <div class="d-flex a-center" style="margin-bottom: 26px">
            <div
              style="
                text-align: right;
                padding-right: 10px;
                font-size: 0.875rem;
                width: 7.25rem;
              "
            >
              会议开始时间
            </div>
            <el-date-picker
              v-model="queryInfo.beginTime"
              type="datetime"
              placeholder="选择开始时间"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
            <div
              style="
                text-align: right;
                padding-right: 10px;
                font-size: 0.875rem;
                width: 7.25rem;
                margin-left: 150px;
              "
            >
              会议结束时间
            </div>
            <el-date-picker
              v-model="queryInfo.endTime"
              type="datetime"
              placeholder="选择结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </div>
          <div class="d-flex a-center" style="margin-bottom: 26px">
            <santakinput
              field="queryInfo"
              fieldName="sponsor"
              santakLabel="主办方"
              labelWidth="116"
              :defaultValue="queryInfo.sponsor"
            ></santakinput>
            <santakinput
              santakLabel="协办方"
              labelWidth="116"
              field="queryInfo"
              :defaultValue="queryInfo.coSponsor"
              style="margin-left: 150px"
              fieldName="coSponsor"
            ></santakinput>
          </div>
          <div class="d-flex a-center" style="margin-bottom: 26px">
            <santakinput
              santakLabel="赞助商"
              labelWidth="116"
              field="queryInfo"
              :defaultValue="queryInfo.organizer"
              fieldName="organizer"
            ></santakinput>
            <santakinput
              santakLabel="活动地址"
              labelWidth="116"
              field="queryInfo"
              :defaultValue="queryInfo.activityAddress"
              fieldName="activityAddress"
              style="margin-left: 150px"
            ></santakinput>

            <!-- <el-button style="margin-left: 15px" @click="queryLocation"
              >校验位置</el-button
            > -->
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="位置" :visible.sync="isLocationShow" class="dialog" width="70%"> 

      <location :locationName="locationName"></location>
      
      <!-- <location></location> -->

      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelClick">取 消</el-button>
        <el-button type="primary" @click="confirmClick">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { activityInsert, activityUpdate } from "../../api/serviceRequestAdmin";
import Location from "../../components/Location.vue";


export default {
  components: {
    Location,
    
  },
  name: "NewMeeting",
  data() {
    return {
      username: "",
      queryInfo: {
        activityName: "",
        startTime: "", //报名截止时间
        beginTime: "",
        endTime: "",
        sponsor: "",
        coSponsor: "",
        organizer: "",
        activityAddress: "",
        latitude: 0,
        longitude: 0,
      },
      preventDbClick: true,
      isLocationShow: false,
      locationName: "",
      isPositionCorrect: false,
    };
  },

  methods: {
    async init() {},
    goIndex() {
      this.$router.back();
    },
    async addNewServer() {
      
      if (this.preventDbClick === true) {
        let obj = Object.assign({}, this.queryInfo);
        // console.log(obj.activityAddress);
        if (obj.activityName == "") {
          this.$message.error("活动名称为必填！");
          return;
        } else if (obj.activityAddress == "") {
          this.$message.error("活动地址为必填！");
          return;
        } 
    
        this.preventDbClick = false;
        try {
          let IfUpdate = this.$route.query.data === undefined;
          let note = IfUpdate ? "确定新增该会议？" : "确定提交修改？";
          let res;
          await this.$confirm(note, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          });
          if (!IfUpdate) {
            res = await activityUpdate(obj);
          } else {
            res = await activityInsert(obj);
          }
          if (res.status == 200) {
            let { id } = res.result;
            this.$message({
              message: IfUpdate
                ? "添加数据成功,1s后跳转到首页"
                : "修改数据成功,1s后跳转到首页",
              type: "success",
            });
            this.timed = setTimeout((_) => {
              this.$router.push({
                name: "Index",
              });
            }, 1500);
          }
          // this.timed = setTimeout((_) => {
          //   this.$router.push({
          //     name: "Index",
          //   });
          // }, 1000);
        } catch (error) {
          this.preventDbClick = true;
        }
      }
    },
    cancel() {
      this.$router.go(-1);
    },
    // queryLocation() {
    //   if(this.queryInfo.activityAddress === '') {
    //     this.$message.error({
    //       message: '请先填写活动地址'
    //     })
    //     return
    //   }
    //   this.isLocationShow = true; //弹出弹窗   
    //   this.locationName = this.queryInfo.activityAddress; //保存在输入框输入的地址
    //   console.log(this.locationName)

      // this.locationName = this.changeLocationName
      // console.log(this.queryInfo.activityAddress)
      // this.$store.commit('setLocation',this.queryInfo.activityAddress)
      // console.log(this.$refs.location)
      
      
    // },
    cancelClick() {
      this.isLocationShow = false
      this.isPositionCorrect = false
    },
    confirmClick() {
      this.isLocationShow = false;
      this.isPositionCorrect = true;

      const { latitude, longitude } = this.$store.state.location;
      this.queryInfo.latitude = latitude;
      this.queryInfo.longitude = longitude;
      console.log(this.queryInfo.latitude,this.queryInfo.longitude)
    },
  },
  beforeDestroy() {
    clearTimeout(this.timed);
  },
  mounted() {
    if (this.$route.query.data) {
      const info = JSON.parse(decodeURIComponent(this.$route.query.data));
      this.queryInfo = info;
    }

    // this.init();
    // let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    // this.username = userInfo.username;
    // if (userInfo.userType == 2) {
    //   this.queryInfo.serviceId = userInfo.userId;
    // }
  },
  watch: {
    'queryInfo.activityAddress'() {
      this.isPositionCorrect = false
    }
  }
};
</script>

<style scoped>
.abc {
  border: 1px solid #ccc;
  border-color: #dedede;
  color: #dedede;
  padding-left: 1.25rem;
  border-radius: 4px;
  width: 21.825rem !important;
  height: 6.25rem !important;
}
.upload {
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  box-sizing: border-box;
  width: 148px;
  height: 148px;
  cursor: pointer;
  line-height: 146px;
  text-align: center;
  vertical-align: top;
}
.mask {
  position: relative;
  width: 166px;
}
.mask .deleteImg {
  position: absolute;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
  /* // background-color:#fff; */
  z-index: 10;
  line-height: 20px;
  text-align: center;
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 21.875rem;
}

.dialog >>> .el-dialog__body {
   padding: 0;
 }
 
</style>
